'use strict';

$ = jQuery;

/*
* Evento de clique nos cards de oferta
*/
$('#jc-offer-slider').on('click', '.card a', function () {
  dataLayer.push({
    'event': 'ga_event',
    'eventCategory': 'Catálogo 0km',
    'eventAction': 'Clique - Oferta',
    'eventLabel': $(this).attr('alt')
  });

  gtag('event', 'Catálogo 0km', {
    'eventAction': 'Clique - Oferta',
    'eventLabel': $(this).attr('alt')
  });
});